export default __webpack_public_path__ + "static/Framegroup-230833e6cc2179348676a0a5aa13123e.png";